export default __webpack_public_path__ + "static/media/student-blue.90d19631.svg";